import React, { useContext, memo } from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';

const ProtectedRouteComponent = ({ children }) => {
	const { state } = useContext(AuthContext);
	const authStatus = Cookies.get('auth-status');

	// Check for authentication status
	const isAuthenticated = state.loggedIn || authStatus === 'authenticated';

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}
	return children;
};

ProtectedRouteComponent.propTypes = {
	children: PropTypes.node.isRequired
};

// Wrap with React.memo to prevent re-renders when props haven't changed
const ProtectedRoute = memo(ProtectedRouteComponent);

export default ProtectedRoute;
